<template>
  <div id="shopping-cart-pop-up-offers-view">
    <div class="d-flex justify-content-between align-items-center title-block border-bottom ml-3">
      <PageTitleComponent pageTitle="Warenkorb Pop-Ups" category="Werbeinhalte" categoryIcon="ad" />
      <CreateShoppingCartPopUpOfferComponent />
    </div>
    <div class="pl-3 py-3">
      <div class="mt-2 alert alert-warning" v-if="offers === null">Hier gibt es noch nichts zu sehen. Klicke auf "Erstellen" um das zu ändern. 😉</div>
      <b-tabs v-else-if="Object.keys(offers).length > 0">
        <b-tab title="Aktuell" active v-if="Object.keys(activeOffers).length > 0">
          <table class="table mt-3">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Anzeigezeitraum</th>
                <th>Sprache</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ShoppingCartPopUpOfferRowComponent v-for="(item, key) in activeOffers" :key="`shopping-cart-pop-up-offer-${key}`" :item="item" :itemKey="key" v-on:selectedItem="selectItem" />
            </tbody>
          </table>
        </b-tab>
        <b-tab title="Abgelaufen" v-if="Object.keys(inactiveOffers).length > 0">
          <table class="table mt-3">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Anzeigezeitraum</th>
                <th>Sprache</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ShoppingCartPopUpOfferRowComponent v-for="(item, key) in inactiveOffers" :key="`shopping-cart-pop-up-offer-${key}`" :item="item" :itemKey="key" v-on:selectedItem="selectItem" />
            </tbody>
          </table>
        </b-tab>
      </b-tabs>
      <SpinnerComponent class="mt-3" v-else />
    </div>
    <EditShoppingCartPopUpOfferComponent
      :modalId="'edit-shopping-cart-pop-up-offer-modal'" 
      :selectedKey="selectedKey" 
      :selectedItem="selectedItem" />
  </div>
</template>

<script>
import PageTitleComponent from '../components/PageTitleComponent'
import SpinnerComponent from '../components/SpinnerComponent'
import CreateShoppingCartPopUpOfferComponent from '../components/CreateShoppingCartPopUpOfferComponent'
import ShoppingCartPopUpOfferRowComponent from '../components/ShoppingCartPopUpOfferRowComponent'
import EditShoppingCartPopUpOfferComponent from '../components/EditShoppingCartPopUpOfferComponent'
import _ from 'lodash'
import moment from 'moment-timezone'

import { db } from "../plugins/firebase"
import { onValue, ref } from "firebase/database"

export default {
  name: 'ShoppingCartPopUpOffersView',
  components: {
    PageTitleComponent,
    SpinnerComponent,
    CreateShoppingCartPopUpOfferComponent,
    ShoppingCartPopUpOfferRowComponent,
    EditShoppingCartPopUpOfferComponent
  },
  methods: {
    selectItem: function(data) {
      this.selectedKey = data.key
      this.selectedItem = data.item
      this.$bvModal.show('edit-shopping-cart-pop-up-offer-modal')
    }
  },
  computed: {
    activeOffers: function() {
      const offers = Object.entries(this.offers).filter(([key, item]) => {
        const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
        const fromTimestamp = moment(item.fromDate).unix()
        const toTimestamp = moment(item.toDate).unix()

        if (
          (fromTimestamp <= nowTimestamp && toTimestamp >= nowTimestamp) ||
          fromTimestamp >= nowTimestamp
        ) {
          return [key, item]
        } 
      })

      const offersSorted = _.orderBy(offers, [(item) => {
        return moment(item[1].toDate)
      }], ['asc'])

      return Object.fromEntries(offersSorted)
    },
    inactiveOffers: function() {
      const offers = Object.entries(this.offers).filter(([key, item]) => {
        const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
        const toTimestamp = moment(item.toDate).unix()

        if (toTimestamp < nowTimestamp) {
          return [key, item]
        } 
      })

      const offersSorted = _.orderBy(offers, [(item) => {
        return moment(item[1].toDate)
      }], ['desc'])

      return Object.fromEntries(offersSorted)
    }
  },
  mounted() {
    onValue(ref(db, 'shoppingCartPopUpOffers'), snapshot => {
      this.offers = snapshot.val()
    })
  },
  data() {
    return {
      offers: [],
      selectedKey: '',
      selectedItem: {}
    }
  }
}
</script>

<style scoped>
#shopping-cart-pop-up-offers-view {
  margin-left: 250px;
}
.title-block {
  height: 120px;
}
</style>